import { render, staticRenderFns } from "./updateUserDialog.vue?vue&type=template&id=28c805dd&scoped=true&"
import script from "./updateUserDialog.vue?vue&type=script&lang=js&"
export * from "./updateUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./updateUserDialog.vue?vue&type=style&index=0&id=28c805dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c805dd",
  null
  
)

export default component.exports